module.exports = __webpack_public_path__ + "img/jianyi.8067e53.png";